import FooterResumenV1 from "../../GenerarDocumento/footers/FooterResumenV1"
import DocumentoTributarioV1 from "../../DetalleDocumento/contents/DocumentoTributarioV1"

export const CreditoFiscalResumen = () => {
  return (
    <>
      <div
          id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6'
          className='w-layout-cell'
          style={{minHeight: '100vh'}}
        >
        <div className='card'>
          <DocumentoTributarioV1 />
        </div>
      </div>
      <FooterResumenV1 />
    </>
  )
}


